// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
import { LogService } from '../app/services';
import { IAppConfig } from './i-app.config';

export function QALogServiceFactory() {
  return new LogService(true, false, true, true);
}
export const OAuthConfig = {
  clearHashAfterLogin: true,
  clientId: 'its-pres-cortrack-test-AB4117E7F3C04C43AD4E1BEF6D001D47',
  issuer: 'https://idp-test.uiowa.edu',
  loginUrl: 'https://idp-test.uiowa.edu/idp/profile/oidc/authorize',
  logoutUrl: 'https://idp-test.uiowa.edu/idp/profile/Logout',
  redirectUri: 'https://cortrack-test.iowa.uiowa.edu',
  responseType: 'code',
  scope: 'openid profile uiowa.identifiers offline_access',

  tokenEndpoint: "https://idp-test.uiowa.edu/idp/profile/oidc/token",
  revocationEndpoint: "https:\/\/idp-test.uiowa.edu\/idp\/profile\/oauth2\/revocation",
    // The IDP does not return an id token during a token refresh. Without disabling the timer here, this
  // leads to an infinite token refresh loop. This is the solution prescribed by the library author.
  disableIdTokenTimer: true, 
};

export const environment = {
  production: false,
  qa: true,
  appConfig: <IAppConfig>{
    logFactory: QALogServiceFactory,
    APIBaseURI: 'https://cortrack-test.iowa.uiowa.edu/api',
    BaseURI: 'https://cortrack-test.iowa.uiowa.edu',
    OAuthConfig: OAuthConfig,
  },
};
